export default "__VITE_ASSET__DkqtvjpG__"